module.exports = __webpack_public_path__ + "img/logo-white.38235d72.png";